import React from 'react';
import { motion } from 'framer-motion';
import { Eye, UserCheck, Wrench, Headphones, Building2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function WhyChooseSection() {
  const {
    t
  } = useLanguage();
  const reasons = [{
    icon: Eye,
    title: t('whyChoose.1.title'),
    description: t('whyChoose.1.desc')
  }, {
    icon: UserCheck,
    title: t('whyChoose.2.title'),
    description: t('whyChoose.2.desc')
  }, {
    icon: Wrench,
    title: t('whyChoose.3.title'),
    description: t('whyChoose.3.desc')
  }, {
    icon: Headphones,
    title: t('whyChoose.4.title'),
    description: t('whyChoose.4.desc')
  }, {
    icon: Building2,
    title: t('whyChoose.5.title'),
    description: t('whyChoose.5.desc')
  }];
  return <section className="bg-navy text-white py-16 md:py-24" data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-140">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-4" data-id="element-141">
            {t('whyChoose.title')}
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-142">
            {t('whyChoose.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-143">
          {reasons.map((reason, index) => {
          const Icon = reason.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-lg hover:bg-opacity-20 transition-all" data-id="element-144">
                <div className="w-12 h-12 bg-gold bg-opacity-20 rounded-lg flex items-center justify-center mb-4" data-id="element-145">
                  <Icon className="text-gold" size={24} data-id="element-146" />
                </div>
                <h3 className="text-xl font-semibold mb-2" data-id="element-147">{reason.title}</h3>
                <p className="text-gray-300" data-id="element-148">{reason.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}